import { StringValues } from '../interfaces/undetermined';

// Constante que guarda el nombre de los atributos que recibe el API de adminisración, segun nombre en los formularios
export const MANAGEMENTSVE: StringValues = {
    enDescription: "description",
    description: "observaciones",
    fulfillment2018: "cumpl18",
    fulfillment2019: "cumpl19",
    fulfillment2020: "cumpl20",
    markerOrder: "markerOrder",
    descriptor: "desc_meta",
    pdfStyles: "pdfStyles",
    file: "archivoupload",
    result2018: "res18",
    result2019: "res19",
    result2020: "res20",
    goal2018: "meta18",
    goal2019: "meta19",
    goal2020: "meta20",
    enModule: "module",
    headers: "headers",
    footers: "footers",
    permits: "permits",
    target: "obj_est",
    operation: "ope",
    pzd2Month: "mes",
    pzd2Year: "anio",
    pzdMonth: "mesC",
    pzdYear: "anioC",
    marker: "marker",
    module: "modulo",
    parent: "parent",
    sheets: "sheets",
    styles: "styles",
    month: "fld_mes",
    year: "fld_anio",
    enOrder: "order",
    event: "evento",
    user: "usuario",
    enUser: "user",
    alias: "alias",
    rules: "rules",
    table: "table",
    entity: "ent",
    order: "ord",
    menu: "menu",
    type: "tipo",
    body: "body",
    link: "link",
    id: "id",
};
